<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>Certifikati {{shema}}</h1>

      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">
      <div>
        <div style="display: 'inline-block';">
            Sezona
            <br />
            <dropdownlist
                :data-items="sezonePisanje"
                :text-field="'sezona'"
                @change="sezonaChange"
                :value="dataSezona"
            /> 
            <pridelovalec :pridelovalec="pridelovalec" :sezona="dataSezona.sezona" shema="IP" :kontrolaid="kontrolaid"
                    :podshema="kontrola.podrocjecertificiranja">

          </pridelovalec>
            
            
          </div>
        </div>
      
    <div class="uporabnik-spacer" style="margin-top:2rem"></div>



	
		
	<div class="left-border-for-children" style="width:'100%'">
		
		<div class="form-fieldset-header mt-1">
			<h2>PREGLED IN ODLOČITEV</h2>
		</div>
		
		<div class="display-row mt-1 display-row-form" >
            <span>Kontrolna številka</span>
             <kinput disabled type="text" v-model="pridelovalec.kontrolnaStevilka"/>
		</div>
		<div class="display-row mt-1 display-row-form" >
            <span>Shema certificiranja</span>
             <kinput disabled type="text" value="Integrirana pridelava"/>
		</div>
		<div class="display-row mt-1 display-row-form" >
            <span>Področje</span>
			<kinput disabled type="text" :value="podrocjacertificiranja.find(g=>g.naziv==kontrola.podrocjecertificiranja)?podrocjacertificiranja.find(g=>g.naziv==kontrola.podrocjecertificiranja).prikaz:''"/>
            
		</div>
		<div class="display-row mt-1 display-row-form" >
            <span>Ocena tveganja</span>
             <kinput disabled type="text" v-model="pridelovalec.ocenatveganja"/>
		</div>
		<div class="display-row mt-1 display-row-form" >
            <span>Status kontrole</span>
			<kinput disabled type="text" v-model="kontrola.status"/>
            
		</div>
		<div class="display-row mt-1 display-row-form" >
            <span>Član skupine</span>
			<kinput disabled type="text" v-model="pridelovalec.skupina"/>
		</div>

		<div class="form-group">
		<div class="km-widget km-buttongroup k-widget k-button-group">
			<button class="k-button k-primary" :disabled="pridelovalec.pisanje==0" @click="shraniKontrolo" >Shrani odločitev</button>
			<button class="k-button k-primary" @click="nazaj" >Nazaj</button>
		</div>

    	</div>


		<div class="form-fieldset-header mt-1">
			<h2>Pregled kontrolne dokumentacije</h2>
		</div>
		<div>  
		<label for="datumnadzora" class="display-row mt-1 display-row-form">
            <span>Datum pregleda:</span>
             <kendo-datepicker id="datumnadzora"
                       v-model="pregled.datumnadzora"
                       :format="'dd.MM.yyyy'">
            </kendo-datepicker>
        </label>
		</div>
		<div>  
            <label  class="display-row mt-1 display-row-form">
            <span>Izvedel:</span>
            <dropdownlist
								placeholder="Izberi kontrolorja"
                :text-field="'naziv'"
								:data-items="kontrolorji"
								v-model="pregled.kontrolor"
								
			></dropdownlist>
            </label>
        </div>
		<div>  
            <label  class="display-row mt-1 display-row-form">
            <span>Ugotovitve:</span>
             <kinput v-model="pregled.ugotovitve" placeholder="" />
            </label>
        </div>

		<div>  
            <label  class="display-row mt-1 display-row-form">
            <span>Priporočilo certifikatorju:</span>
            <dropdownlist
								placeholder="Izberi kontrolorja"
								:data-items="priporocila"
								v-model="pregled.priporocilo"
								
			></dropdownlist>
			<kendo-datepicker 
                       v-model="pregled.datumpriporocila"
                       :format="'dd.MM.yyyy'">
            </kendo-datepicker>
            </label>
        </div>
		

		<div class="form-fieldset-header mt-1">
			<h2>Odločitev</h2>
		</div>
		<div>  
		<label for="datumnadzora" class="display-row mt-1 display-row-form">
            <span>Datum odločitve:</span>
             <kendo-datepicker 
                       v-model="odlocitev.datumodlocitve"
                       :format="'dd.MM.yyyy'">
            </kendo-datepicker>
        </label>
		</div>
		<div>  
            <label  class="display-row mt-1 display-row-form">
            <span>Izvedel:</span>
            <dropdownlist
								placeholder="Izberi kontrolorja"
                :text-field="'naziv'"
								:data-items="kontrolorji"
								v-model="odlocitev.kontrolor"
								
			></dropdownlist>
            </label>
        </div>

		<div>  
            <label  class="display-row mt-1 display-row-form">
            <span>Odločitev:</span>
            <multiselect
								placeholder="Odločitev"
								:data-items="odlocitve"
								v-model="odlocitev.odlocitev"
								
			></multiselect>
            </label>
        </div>
        <div>  
            <label  class="display-row mt-1 display-row-form">
            <span>Številka poročila:</span>
             <kinput v-model="odlocitev.stevilkaporocila" placeholder="" />
            </label>
        </div>

        <div>  
		    <label for="datumporocila" class="display-row mt-1 display-row-form">
            <span>Datum poročila:</span>
             <kendo-datepicker 
                       v-model="odlocitev.datumporocila"
                       :format="'dd.MM.yyyy'">
            </kendo-datepicker>
        </label>
		</div>
    <div>  
            <label  class="display-row mt-1 display-row-form">
            <span>Priloge:</span>
            <multiselect
								placeholder="Priloge"
								v-model="odlocitev.priloge"
                allowCustom="true"
								
			></multiselect>
            </label>
        </div>
		
		<div class="form-fieldset-header mt-1">
			<h2>Certificirani proizvodi / dejavnost: {{ kontrola.podrocjecertificiranja }}</h2>
				
				<div class="k-form-field">
          <multiselect v-model="kontrola.certificiranobseg"
                        :data-items="ipobsegcertificiranjafilter"
                        :text-field="'naziv'"
                        :data-item-key="'šifra'"
                        :placeholder="'Izberi'"
                        id="obseg"
                        
                        :filterable="true"
						@filterchange="onFilterChange($event,kontrola.podrocjecertificiranja)"
                        :style="{ width: '400px'}"
						
                        >
						
            	</multiselect>
              </div>
		</div>

	</div>





    <Grid  
                       
                      
                        :data-items="gridData"
                        :columns="columns"
                          @datastatechange="dataStateChange"
                       
                       :edit-field="'inEdit'"
                        @itemchange="itemChange"

                        
                         :row-render="rowRenderFunction"
                      
                        

                         
                        
                                               >
                  <template v-slot:ukaznigumbi="{props}">
                  <ukaznigumbiknt :data-item="props.dataItem"   :editDisabled="editDisabled"
                    @edit="edit"
                    @save="saveItem" 
                    @remove="removeItem"
                    @cancel="cancel"/>

                    </template>

                    <template v-slot:shranigumb="{props}">
                      <button
                             :disabled="editDisabled"
                                title="Shrani kulture"
                                class="k-button k-primary"
                                @click="shraniKulture(props.dataItem)"
                            >
                                Shrani
                            </button>
                    </template>
                   <template v-slot:certifikatLink="{props}">
                    <td>
                      <a
                        class="k-primary k-button k-grid-edit-command" :disabled="editDisabled"
                        :href="'/javno/certifikatpdfip/'+props.dataItem._id" target="_blank" title="Certifikat">
                         <font-awesome-icon icon="certificate"/>                        
                    </a>
					&nbsp;
                    <a
                        class="k-primary k-button k-grid-edit-command" :disabled="editDisabled"
						:href="'/javno/certifikatporocilopdfip/'+props.dataItem._id" target="_blank" title="Poročilo">
                         <font-awesome-icon icon="file-lines"/>                       
                    </a>
                </td>
                    </template>
                   
                    <template v-slot:certifikatPDFLink="{props}">
                    <td>
                      <a
                        class="k-primary k-button k-grid-edit-command" :disabled="editDisabled"
                        :href="apiUrl+'/certifikati/print/?url='+baseUrl+'/javno/certifikatpdf/'+props.dataItem._id+'&ime='+props.dataItem.stevilkacertifikata" target="_blank" title="Poglej">
                         <font-awesome-icon icon="file-pdf"/>&nbsp;
                         
                    </a>
                    &nbsp;
                    <a
                        class="k-primary k-button k-grid-edit-command" :disabled="editDisabled"
                        :href="apiUrl+'/certifikati/print/?url='+baseUrl+'/javno/certifikatpdf/'+props.dataItem._id+'?lang=en&ime='+props.dataItem.stevilkacertifikata" target="_blank" title="Poglej">
                         <font-awesome-icon icon="file-pdf"/> (en)
                         
                    </a>
                </td>
                    </template>

                     <template v-slot:certifikatPDFAngLink="{props}">
                    <td>
                      <a
                        class="k-primary k-button k-grid-edit-command" :disabled="editDisabled"
                        :href="'/javno/certifikatpdfang/'+props.dataItem._id" target="_blank" title="Poglej angleško">
                         <font-awesome-icon icon="file-pdf"/>
                         
                    </a>
                </td>
                    </template>


                    

                 <toolbar>
                             
                        <div class="km-widget km-buttongroup k-widget k-button-group">
                        <button :disabled="editDisabled"
                                title="Dodaj"
                                class="k-button k-primary"
                                @click="insert">
                                Dodaj certifikat
                       </button>
                        </div>
                            
                        </toolbar>
                         <GridNoRecords >
                    <div v-if="dataLoading" class="k-loading-mask loadingIconSpace">
                      <span class='k-loading-text'></span>
                      <div class='k-loading-image'></div>
                      <div class='k-loading-color'></div>
                      
                    </div>
                    <div v-else>
                      Ni podatkov!
                    </div>
                    </GridNoRecords>
                    </Grid>

                    </div>
    </div>

</template>
<style scoped>
	.mt-1 {
	margin-top: 1rem !important;
	}

	.display-row{
		display:flex;
		align-items:center;
		gap:1rem;
		
	}
	.display-row-form>*:first-child{
		flex:0 0 25%;
	}
</style>

<script>
import { mapState, mapActions,mapMutations } from 'vuex'
import '@progress/kendo-ui' 
import '@progress/kendo-theme-default/dist/all.css'
import Vue from 'vue';

import { Grid, GridToolbar, GridNoRecords  } from '@progress/kendo-vue-grid';
import { DropDownList,MultiSelect } from '@progress/kendo-vue-dropdowns';
import StatusCommandCell from './support/SifrantStatusovCommandCell';
import PridelovalecKratko from './support/PridelovalecKratko';
import { kontrolaService } from '../services/kontrola.service';
import { filterBy } from '@progress/kendo-data-query';
import { DatePicker, DateTimePicker } from '@progress/kendo-vue-dateinputs';
import { Input } from '@progress/kendo-vue-inputs';
import { Button, ButtonGroup } from '@progress/kendo-vue-buttons';
import { process } from '@progress/kendo-data-query';
import moment from 'moment'
import { provideIntlService } from '@progress/kendo-vue-intl';



export default {
  components:{

	'kinput': Input,
	'kbutton': Button,
	'kendo-datepicker': DatePicker,
	'kendodatetimepicker': DateTimePicker,
     'ukaznigumbiknt': StatusCommandCell,
      'dropdownlist': DropDownList,
	  'multiselect': MultiSelect,
      'Grid': Grid,
      'GridNoRecords': GridNoRecords,
      'toolbar': GridToolbar,
       'pridelovalec':PridelovalecKratko
  },
  props:['sezona','pridelovalecid','shema','kontrolaid'],
    data () {
        return {
          ipobsegcertificiranjafilter:[],
            sifrantTree:{},
            dataLoading:false,
            apiUrl:Vue.prototype.$config.apiUrl,
            dataSezona:this.sezona,
			podrocjacertificiranja:[],
            baseUrl:window.location.origin,
            updatedData: [],
            editID: null,
            odlocitev:{},
            pregled:{},
			      kontrola:{},
			ip:{},
			kontrolorji:[],
			priporocila:["Da","Ne","Delno","Vračilo v ponovno vrednotenje"],
			odlocitve:["Odobritev - v celoti","Odobritev - delno","Odobritev - širitev","Odobritev - oženje","Odobritev spremembe","Odobritev - obstoječi","Zavrnitev","Razveljavitev","Začasni odvzem"],
         
            sort: [
                //{ field: 'vrstakulture', dir: 'asc' }
            ],
            columns: [
           
                { field: "stevilkacertifikata", title:"Številka",width: "170px"},
                { field: "datumizdaje", title:"Datum izdaje", editor: 'date',width: "170px",format: '{0:d}',validation: { required: true}},
                { field: "datumveljavnosti", title:"Datum veljavnosti", editor: 'date',width: "170px",format: '{0:d}',validation: { required: true}},
                { field: "stariCertifikat", title:"Zamenjuje certifikat št.:",width: "150px"},
          
                { field: "veljaven", title:"Veljaven", editor: 'boolean',width: "70px", cell:this.veljavenIcon,validation: { required: true}},
                { title: "Certifikat", cell: 'certifikatLink',filterable:false,columnMenu: null,width:"140px",sortable:false},
              
                
               { cell: 'ukaznigumbi', width: '210px', hidden:this.editDisabled },
               { cell: 'shranigumb', width: '80px', hidden:this.editDisabled },
              
              
              
            ],
          

           

        }
    },
      computed: {

      
        editDisabled(){
          return (this.pridelovalec.pisanje==0)
        },
        ...mapState({gridData(state) {
       
          return state.certifikat.certifikat;
        }}),
        ...mapState({zadnjastevilka(state) {
      
          return state.certifikat.zadnjastevilka;
        }}),

        ...mapState('pridelava', ['pridelovalec']) ,
        ...mapState('sifrant', ['sifrant']) ,
        ...mapState('users',['sezonePisanje']),

        
      
           },
    created () {

      //potegni šifrant iz sifrantstore
     /* var groupedAreas = [];
dataItems.map(function(d) {
  if(groupedAreas.filter(function(item, i) {
   return item.areaName === d.AreaName; 
  }).length === 0) {
    groupedAreas.push({ areaName: d.AreaName, subsidiaries:  dataItems.filter(function(r) { return r.AreaName === d.AreaName; }) });
  }
});*/
 if(!this.sezona)
        this.dataSezona={sezona:2022};
      else
      this.dataSezona={sezona:this.sezona};
this.naloziPodatke();

      
    },
  


    methods: {
        ...mapActions('certifikat', ['load','save','loadstcert','saveCert']),
        ...mapActions({naloziSifrant: 'sifrant/load'}),
        ...mapMutations('certifikat',['update',"add","remove","makeEditable",'replace']),
        ...mapActions('pridelava', ['loadIdPoSezoni','loadOne']),
        //...mapActions('sifrant', ['load']),
         veljavenIcon: function (h, defaultElement , props, listeners ) {
            if(props.dataItem.inEdit)
                return defaultElement;

            let veljaven=h('font-awesome-icon',{props:{icon:"times"}});
            if(props.dataItem.veljaven)
                veljaven=h('font-awesome-icon',{props:{icon:"check"}},{class:{"action_success":true}});
            let veljavenWrapper=h('span', {class:{
                'k-badge':true,'k-badge-solid':true,'k-badge-md':true,'k-badge-pill':true,
                "action_error":!props.dataItem.veljaven,"action_success":props.dataItem.veljaven}}, [veljaven]);
            return h('td', {attrs:{colspan:1}}, [veljavenWrapper]);
        },
        rowRenderFunction: function (h, trElement , defaultSlots, props ) {
            console.log(trElement);
            console.log(props.dataItem);
            if(!props.dataItem.jeaktivna)
            trElement.data.class+=" deleted_element";

                return trElement;
            },
            onFilterChange(event,podshema) {
			console.log(podshema)
            
			Vue.set(this,'ipobsegcertificiranjafilter',filterBy(this.ip.prijava.obseg[podshema].slice(), event.filter))
		
        },
        naloziPodatke: function(){
          console.log("Nalagam vse podatke")
			this.dataLoading=true;
			let sezona=this.dataSezona.sezona;
			let shema="IP";
			let pridelovalecid=this.pridelovalecid;
			let thisComp=this;
			var sifranti=[
			this.naloziSifrant({sezona:sezona,sifrant:"kontrolorjiip"}).then(
			 	data=>{
				this.kontrolorji=this.sifrant["kontrolorjiip"];
        console.log("Kontrolorji")
				},
  				error=>{console.log("tukaj sem!!!");this.dataLoading=false;}
				),
			
			/*this.naloziSifrant({sezona:sezona,sifrant:"ipobsegcertificiranja"}).then(()=>{
        console.log("obseg")
            thisComp.ipobsegcertificiranja=thisComp.sifrant["ipobsegcertificiranja"];
			for (let podshema of thisComp.podrocjacertificiranja){
        
				Vue.set(thisComp.ipobsegcertificiranjafilter,podshema.naziv,thisComp.ipobsegcertificiranja.filter(i=>i.področje==podshema.naziv).slice())
        console.log("obseg end")
      }
				
        	}),
          */
			this.naloziSifrant({sezona:sezona,sifrant:"podrocjaip"}).then(
			 	data=>{
          console.log("Področja");

				this.podrocjacertificiranja=this.sifrant["podrocjaip"];
        console.log("podrocja end")
				},
  				error=>{console.log("tukaj sem!!!");this.dataLoading=false;}
				),
		
		];
		
		//to bi bilo dobro imet na enem mestu kot helper!!!
		Promise.all(sifranti).then(()=>{
			console.log("Šifranti naloženi")
				
			this.loadOne({sezona:sezona,pridelovalecid:pridelovalecid}).then(p=>{
			//kontakti kmetije				
      console.log("Stranka naložena")
			let kontaktkmg=p.kontakt.find(k=>k.vloga=="kmetija (kmg)")
                if(!kontaktkmg)
                    kontaktkmg=p.kontakt.find(k=>k.glavni)
                if(!kontaktkmg)
                    kontaktkmg=p.kontakt[0];

				let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==sezona&&s.shema==shema);
				if(!pridelava){
				console.log("resne težave, če ni sheme")
				return;
				}
				this.pridelovalec.kontrolnaStevilka=pridelava.kontrolnaStevilka;
				let novaprijava={
				obseg:{},
				seznam:{datotekaid:null,files:[]},
				datumseznama:(new Date()).toISOString()};
				if(!pridelava.ip)
				{
					Vue.set(pridelava.ip,'prijava',novaprijava)
				}
				if(!pridelava.ip.prijava){
					Vue.set(pridelava.ip,'prijava',novaprijava)
		}
			Vue.set(thisComp,"ip",pridelava.ip)
		
			if(!thisComp.ip.prijava.obseg||Array.isArray(thisComp.ip.prijava.obseg))
			Vue.set(thisComp.ip.prijava,'obseg',{});

      

     
		this.load({sezona:this.dataSezona.sezona,strankaid:this.pridelovalecid,makeEditable:!this.editDisabled,shema:this.shema}).then(
          data=>{this.dataLoading=false;   console.log("Certifikati naloženi")},
          error=>{console.log("tukaj sem!!!");this.dataLoading=false;
		});
        
      
		kontrolaService.loadOne(sezona,pridelovalecid,shema,this.kontrolaid).then(
			data=>{
        console.log("kontrola naložena")
        thisComp.ipobsegcertificiranjafilter=thisComp.ip.prijava.obseg[data.podrocjecertificiranja].slice();

        //kopiramo obseg v certifirian obseg v celoti... če še ni nič nastavljeno..
        if(!data.certificiranobseg||data.certificiranobseg.length<=0)
          data.certificiranobseg=thisComp.ipobsegcertificiranjafilter.slice();
        console.log(thisComp.ip.prijava.obseg);
        console.log(data.podrocjecertificiranja);
          console.log(data.certifirianobseg);
				var datumi=["datumkontrole","datumnadzora","zacetekkontrole","koneckontrole","datumnajave"]
				//vzorci datum pregleda
				//datumzadnjeaktivnosti podizvajalci in stortivepodizvajalca
				//izvajalcikontrole datum
				data.vzorci.forEach(v=>{
					v.datumvzorcenja=provideIntlService(thisComp).parseDate( v.datumvzorcenja);
					v.datumizvida=provideIntlService(thisComp).parseDate( v.datumizvida);
					v.datumpregleda=provideIntlService(thisComp).parseDate( v.datumpregleda);
					
				})
				//kontrolor v kontrolorji
				if(!data.kontrolorji)
					data.kontrolorji=[];
				if(!data.kontrolorji.includes(data.kontrolornaziv))
					data.kontrolorji.push(data.kontrolornaziv);

				for (let d of datumi){
					if(data[d])
						data[d]=provideIntlService(thisComp).parseDate( data[d]);
				}

				console.log(data);
				data.lokacijakontrolenaslov=data.lokacijakontrolenaslov?data.lokacijakontrolenaslov:kontaktkmg.naslov;
				data.lokacijakontroleposta=data.lokacijakontroleposta?data.lokacijakontroleposta:kontaktkmg.posta;
				data.lokacijakontrolepostnastevilka=data.lokacijakontrolepostnastevilka?data.lokacijakontrolepostnastevilka:kontaktkmg.postnastevilka;
				
				if(!data.pregled){
            data.pregled={
              datumnadzora:new Date(),
		          kontrolor:{},
		          ugotovitve:"",
		          priporocilo:"",
		          datumpriporocila:new Date()}
        }
        else  {
          data.pregled.datumnadzora=provideIntlService(thisComp).parseDate(data.pregled.datumnadzora);
          data.pregled.datumpriporocila=provideIntlService(thisComp).parseDate(data.pregled.datumpriporocila);
        }
        
        if(!data.odlocitev||!data.odlocitev.datumodlocitve){
          data.odlocitev={
            datumodlocitve:new Date(),
            datumporocila:new Date(),
		        kontrolor:{},
		        odlocitev:[],
            stevilkaporocila:"",
            priloge:[]
          }
        }
        else  {
          data.odlocitev.datumodlocitve=provideIntlService(thisComp).parseDate(data.odlocitev.datumodlocitve);
          data.odlocitev.datumporocila=provideIntlService(thisComp).parseDate(data.odlocitev.datumporocila?data.odlocitev.datumporocila:new Date());
          
        }

       
        Vue.set(thisComp,'odlocitev',data.odlocitev);
        Vue.set(thisComp,'pregled',data.pregled);
				Vue.set(thisComp,'kontrola',data);

			},
			err=>{}
		);

		

	  

		});

	});
	
          
        
      






        

        
        },
        
        itemChange: function (e) {
            //const updatedData  = this.gridData.slice();
            if(!e.dataItem.oldValues)
              e.dataItem.oldValues={}
            if(!e.dataItem.oldValues[e.field])
              e.dataItem.oldValues[e.field] =e.dataItem[e.field];
          
          e.dataItem[e.field] = e.value;
          if(e.field=="veljaven")
            e.dataItem[e.field]=e.value?1:0;
          
         //   const item = this.update(e.dataItem);
            //item[e.field] = e.value;
            //this.repalce(updatedData);
        },
        izvozi(){
          var route=this.$router.resolve({ name: 'certificiranpridelekPDF', params: {sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalec._id,shema:this.shema} });
          window.open(route.href, '_blank');
        },
        certificiranje(){
          var route=this.$router.resolve({ name: 'certificiranjePDF', params: {sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalec._id,shema:this.shema} });
          window.open(route.href, '_blank');
        },

         insert() {
            this.loadstcert({sezona:this.dataSezona.sezona,shema:this.shema}).then(data=>{
                const dataItem = { inEdit: true,jeaktivna:true,
                datumveljavnosti:new Date(this.dataSezona.sezona*1+1,11,31),
                datumizdaje:new Date(),
                veljaven:1,
                shema:this.shema,
                strankaid:this.pridelovalecid,
                sezona:this.dataSezona.sezona,
				kontrolaid:this.kontrolaid,                  
                stevilkacertifikata:(data+1)+"-"+this.dataSezona.sezona.toString().substring(2,4)+"-06"
                   };
            //const newproducts = this.gridData.slice();
            //newproducts.unshift(dataItem);
            this.add(dataItem);

			console.log("Shranjujem!!");
			dataItem.kontrolaid=this.kontrolaid;
          	console.log(dataItem);
			

              this.saveCert({certifikat:dataItem});

            })
           
          //  this.repalce(newproducts);
        },
        edit: function (e) {
          //console.log(e);
            console.log(e.dataItem)
            e.dataItem.inEdit = true;
            e.dataItem.jeaktivna = true;
            
            this.update(e.dataItem);
            console.log(this.kultura);
        },
        cancel(e) {
            if (e.dataItem.id>0) {
            var dataItem=e.dataItem;
            for (const value in dataItem.oldValues){
                dataItem[value]=dataItem.oldValues[value];
            }
              this.update(dataItem);
            
            } else {
                this.remove(e.dataItem);
            }
        },
        saveItem: function(e) {
          console.log(e.dataItem);
          for (const value in e.dataItem.newValues){
            e.dataItem[value]=e.dataItem.newValues[value];
          }
           e.dataItem.inEdit = undefined;
             e.dataItem.jeaktivna = true;
          //  const data = this.gridData.slice();
            this.update(e.dataItem);
            //e.dataItem.id = this.update(kulture, e.dataItem).id;
        },
        removeItem(e) {

            if (e.dataItem.inEdit)
                e.dataItem.jeaktivna = false;
            else
                e.dataItem.jeaktivna = true;  
            e.dataItem.inEdit =!e.dataItem.inEdit;
            //this.update(this.gridData, e.dataItem, true);
              
            this.update(e.dataItem);

            //this.remove(e.dataItem);
            //console.log(this.gridData);
            //this.replace(this.gridData.slice());
        },
     nogaVsotaPovrsin: function (h, emptyElement , props, listeners ) {
          if(this.kulture)
            return h('span', {}, ['Vsota površin: ' + this.kulture.reduce((acc, current) => acc+=current.povrsina, 0).toFixed(2)+ ' ha']);
        },
     nogaVsotaKolicin: function (h, emptyElement , props, listeners ) {
          if(this.kulture)
            return h('span', {}, ['Vsota količin: ' + this.gerk.reduce((acc, current) => acc+=current.povrsina, 0).toFixed(2)]);
        },
    

       sezonaChange(event) {
             const sezona = event.value;
            this.dataSezona=sezona;
            //this.loadIdPoSezoni({sezona:sezona.sezona,pridelovalecid:this.pridelovalecid}).then(pridelovalec=>{
              //this.pridelovalecid=pridelovalec.id;
              this.$router.push({ name: 'certifikatip', params: {sezona:sezona.sezona,pridelovalecid:this.pridelovalec._id,kontrolaid:this.kontrolaid,podshema:this.kontrola.podrocjecertificiranja}} );
           
             this.naloziPodatke();
             // });



        },
dataStateChange (event) {
            console.log("DataStateChange");
            console.log(event);
            this.createAppState(event.data);
                 //  console.log(this.skip);
            this.dataResult = process(this.gerk, {});
           // console.log(this.dataResult);

        },
      
        shraniKulture (certifikat) {
          //  this.$router.go(-1);
          console.log("Shranjujem!!");
		  certifikat.kontrolaid=this.kontrolaid;
          console.log(certifikat);
			

              this.saveCert({certifikat:certifikat});
      //         this.load({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid});

                     
        },
        async shraniKontrolo () {
			//kaj narediš s seznamom in obsegom.... vprašaj...
			//this.save( this.dataSezona);
			//if(this.kontrola.datumnajave&&this.kontrola.status=="nova")
			//this.kontrola.status="v teku";
      //če je odločitev, spremeni status kontrole..., samo če je prej v pregled...
      

          
      //kontrola v konačna
          // če priporocila da ne delno -> odločitev
          //če ostalo -> vracilo v ponovno vrednotenje

          if(this.kontrola.pregled?.priporocilo=="Vračilo v ponovno vrednotenje")
            this.kontrola.status="vračilo v ponovno vrednotenje";
          else
          this.kontrola.status="odločitev";
          
          if(this.odlocitev.odlocitev.length>0)
            this.kontrola.status="konec";
          


			await kontrolaService.saveOne(this.kontrola,this.sezona,this.pridelovalecid,this.shema,this.kontrolaid)
			
			//shrani obseg...

              //this.save();
    },
       
        /*
        changeStatus: function (e) {
            console.log("Gerk change!!!");
            console.log(e.dataItem);
          //  Vue.set(e.dataItem, 'inEdit', true);
        },
*/
        //do doli
        
    }
};
</script>

